export default class ReportService {
  constructor (http, store, router) {
    this.$http = http
    this.$store = store
    this.$router = router
  }

  getSupplierPayments (query) {
    return new Promise((resolve, reject) => {
      this.$http.get('reports/supplier/payment', { params: query })
        .then(res => res.data)
        .then(data => {
          resolve(data)
        })
        .catch(reject)
    })
  }

  getSupplies (query) {
    return new Promise((resolve, reject) => {
      this.$http.get('reports/supplies', { params: query })
        .then(res => res.data)
        .then(data => {
          resolve(data)
        })
        .catch(reject)
    })
  }

  getCurrentPayroll (query) {
    return new Promise((resolve, reject) => {
      this.$http.get('reports/expected-expenditure', { params: query })
        .then(res => res.data)
        .then(data => {
          resolve(data)
        })
        .catch(reject)
    })
  }

  getEmployeeDebts (query) {
    return new Promise((resolve, reject) => {
      this.$http.get('reports/employee-debts', { params: query })
        .then(res => res.data)
        .then(data => {
          resolve(data)
        })
        .catch(reject)
    })
  }

  getDeposits (query) {
    return new Promise((resolve, reject) => {
      this.$http.get('reports/deposits', { params: query })
        .then(res => res.data)
        .then(data => {
          resolve(data)
        })
        .catch(reject)
    })
  }

  getWithdrawals (query) {
    return new Promise((resolve, reject) => {
      this.$http.get('reports/withdrawals', { params: query })
        .then(res => res.data)
        .then(data => {
          resolve(data)
        })
        .catch(reject)
    })
  }

  queryInventory (query) {
    return new Promise((resolve, reject) => {
      this.$http.get('reports/inventories', { params: query })
        .then(res => res.data)
        .then(data => {
          resolve(data)
        })
        .catch(reject)
    })
  }

  // ==================== SALES SUMMARY REPORTS ====================

  getSalesSummary (query) {
    return new Promise((resolve, reject) => {
      this.$http.get('reports2/sales-summary', { params: query })
        .then(res => res.data)
        .then(data => {
          resolve(data)
        })
        .catch(reject)
    })
  }

  getSalesByPeriod (query) {
    return new Promise((resolve, reject) => {
      this.$http.get('reports2/sales-by-period', { params: query })
        .then(res => res.data)
        .then(data => {
          resolve(data)
        })
        .catch(reject)
    })
  }

  getSalesByEmployee (query) {
    return new Promise((resolve, reject) => {
      this.$http.get('reports2/sales-by-employee', { params: query })
        .then(res => res.data)
        .then(data => {
          resolve(data)
        })
        .catch(reject)
    })
  }

  getSalesByCustomer (query) {
    return new Promise((resolve, reject) => {
      this.$http.get('reports2/sales-by-customer', { params: query })
        .then(res => res.data)
        .then(data => {
          resolve(data)
        })
        .catch(reject)
    })
  }

  getSalesByPaymentMethod (query) {
    return new Promise((resolve, reject) => {
      this.$http.get('reports2/sales-by-payment-method', { params: query })
        .then(res => res.data)
        .then(data => {
          resolve(data)
        })
        .catch(reject)
    })
  }

  getTopSellingItems (query) {
    return new Promise((resolve, reject) => {
      this.$http.get('reports2/top-selling-items', { params: query })
        .then(res => res.data)
        .then(data => {
          resolve(data)
        })
        .catch(reject)
    })
  }

  getSalesTrends (query) {
    return new Promise((resolve, reject) => {
      this.$http.get('reports2/sales-trends', { params: query })
        .then(res => res.data)
        .then(data => {
          resolve(data)
        })
        .catch(reject)
    })
  }

  getSalesDetailed (query) {
    return new Promise((resolve, reject) => {
      this.$http.get('reports2/sales-detailed', { params: query })
        .then(res => res.data)
        .then(data => {
          resolve(data)
        })
        .catch(reject)
    })
  }

  // ==================== CATEGORY-BASED SALES REPORTS ====================

  getSalesByCategory (query) {
    return new Promise((resolve, reject) => {
      this.$http.get('reports2/sales-by-category', { params: query })
        .then(res => res.data)
        .then(data => {
          resolve(data)
        })
        .catch(reject)
    })
  }

  getCategoryPerformance (query) {
    return new Promise((resolve, reject) => {
      this.$http.get('reports2/category-performance', { params: query })
        .then(res => res.data)
        .then(data => {
          resolve(data)
        })
        .catch(reject)
    })
  }

  getCategoryTrends (query) {
    return new Promise((resolve, reject) => {
      this.$http.get('reports2/category-trends', { params: query })
        .then(res => res.data)
        .then(data => {
          resolve(data)
        })
        .catch(reject)
    })
  }

  getCategoryItems (query) {
    return new Promise((resolve, reject) => {
      this.$http.get('reports2/category-items', { params: query })
        .then(res => res.data)
        .then(data => {
          resolve(data)
        })
        .catch(reject)
    })
  }

  getCategoryComparison (query) {
    return new Promise((resolve, reject) => {
      this.$http.get('reports2/category-comparison', { params: query })
        .then(res => res.data)
        .then(data => {
          resolve(data)
        })
        .catch(reject)
    })
  }

  // ==================== ITEM-BASED SALES REPORTS ====================

  getSalesByItem (query) {
    return new Promise((resolve, reject) => {
      this.$http.get('reports2/sales-by-item', { params: query })
        .then(res => res.data)
        .then(data => {
          resolve(data)
        })
        .catch(reject)
    })
  }

  getItemPerformance (query) {
    return new Promise((resolve, reject) => {
      this.$http.get('reports2/item-performance', { params: query })
        .then(res => res.data)
        .then(data => {
          resolve(data)
        })
        .catch(reject)
    })
  }

  getItemTrends (query) {
    return new Promise((resolve, reject) => {
      this.$http.get('reports2/item-trends', { params: query })
        .then(res => res.data)
        .then(data => {
          resolve(data)
        })
        .catch(reject)
    })
  }

  getItemDetails (query) {
    return new Promise((resolve, reject) => {
      this.$http.get('reports2/item-details', { params: query })
        .then(res => res.data)
        .then(data => {
          resolve(data)
        })
        .catch(reject)
    })
  }

  getItemComparison (query) {
    return new Promise((resolve, reject) => {
      this.$http.get('reports2/item-comparison', { params: query })
        .then(res => res.data)
        .then(data => {
          resolve(data)
        })
        .catch(reject)
    })
  }

  getItemSalesHistory (query) {
    return new Promise((resolve, reject) => {
      this.$http.get('reports2/item-sales-history', { params: query })
        .then(res => res.data)
        .then(data => {
          resolve(data)
        })
        .catch(reject)
    })
  }

  // ==================== EMPLOYEE-BASED SALES REPORTS ====================

  getEmployeePerformance (query) {
    return new Promise((resolve, reject) => {
      this.$http.get('reports2/employee-performance', { params: query })
        .then(res => res.data)
        .then(data => {
          resolve(data)
        })
        .catch(reject)
    })
  }

  getEmployeeTrends (query) {
    return new Promise((resolve, reject) => {
      this.$http.get('reports2/employee-trends', { params: query })
        .then(res => res.data)
        .then(data => {
          resolve(data)
        })
        .catch(reject)
    })
  }

  getEmployeeDetails (query) {
    return new Promise((resolve, reject) => {
      this.$http.get('reports2/employee-details', { params: query })
        .then(res => res.data)
        .then(data => {
          resolve(data)
        })
        .catch(reject)
    })
  }

  getEmployeeComparison (query) {
    return new Promise((resolve, reject) => {
      this.$http.get('reports2/employee-comparison', { params: query })
        .then(res => res.data)
        .then(data => {
          resolve(data)
        })
        .catch(reject)
    })
  }

  getEmployeeSalesHistory (query) {
    return new Promise((resolve, reject) => {
      this.$http.get('reports2/employee-sales-history', { params: query })
        .then(res => res.data)
        .then(data => {
          resolve(data)
        })
        .catch(reject)
    })
  }

  getEmployeeCommission (query) {
    return new Promise((resolve, reject) => {
      this.$http.get('reports2/employee-commission', { params: query })
        .then(res => res.data)
        .then(data => {
          resolve(data)
        })
        .catch(reject)
    })
  }

  // ==================== PAYMENT METHOD-BASED SALES REPORTS ====================

  getPaymentMethodPerformance (query) {
    return new Promise((resolve, reject) => {
      this.$http.get('reports2/payment-method-performance', { params: query })
        .then(res => res.data)
        .then(data => {
          resolve(data)
        })
        .catch(reject)
    })
  }

  getPaymentMethodTrends (query) {
    return new Promise((resolve, reject) => {
      this.$http.get('reports2/payment-method-trends', { params: query })
        .then(res => res.data)
        .then(data => {
          resolve(data)
        })
        .catch(reject)
    })
  }

  getPaymentMethodDetails (query) {
    return new Promise((resolve, reject) => {
      this.$http.get('reports2/payment-method-details', { params: query })
        .then(res => res.data)
        .then(data => {
          resolve(data)
        })
        .catch(reject)
    })
  }

  getPaymentMethodComparison (query) {
    return new Promise((resolve, reject) => {
      this.$http.get('reports2/payment-method-comparison', { params: query })
        .then(res => res.data)
        .then(data => {
          resolve(data)
        })
        .catch(reject)
    })
  }

  getPaymentMethodSalesHistory (query) {
    return new Promise((resolve, reject) => {
      this.$http.get('reports2/payment-method-sales-history', { params: query })
        .then(res => res.data)
        .then(data => {
          resolve(data)
        })
        .catch(reject)
    })
  }

  getPaymentMethodAnalysis (query) {
    return new Promise((resolve, reject) => {
      this.$http.get('reports2/payment-method-analysis', { params: query })
        .then(res => res.data)
        .then(data => {
          resolve(data)
        })
        .catch(reject)
    })
  }

  // ==================== MODIFIER-BASED SALES REPORTS ====================

  getSalesByModifier (query) {
    return new Promise((resolve, reject) => {
      this.$http.get('reports2/sales-by-modifier', { params: query })
        .then(res => res.data)
        .then(data => {
          resolve(data)
        })
        .catch(reject)
    })
  }

  getModifierPerformance (query) {
    return new Promise((resolve, reject) => {
      this.$http.get('reports2/modifier-performance', { params: query })
        .then(res => res.data)
        .then(data => {
          resolve(data)
        })
        .catch(reject)
    })
  }

  getModifierTrends (query) {
    return new Promise((resolve, reject) => {
      this.$http.get('reports2/modifier-trends', { params: query })
        .then(res => res.data)
        .then(data => {
          resolve(data)
        })
        .catch(reject)
    })
  }

  getModifierDetails (query) {
    return new Promise((resolve, reject) => {
      this.$http.get('reports2/modifier-details', { params: query })
        .then(res => res.data)
        .then(data => {
          resolve(data)
        })
        .catch(reject)
    })
  }

  getModifierComparison (query) {
    return new Promise((resolve, reject) => {
      this.$http.get('reports2/modifier-comparison', { params: query })
        .then(res => res.data)
        .then(data => {
          resolve(data)
        })
        .catch(reject)
    })
  }

  getModifierSalesHistory (query) {
    return new Promise((resolve, reject) => {
      this.$http.get('reports2/modifier-sales-history', { params: query })
        .then(res => res.data)
        .then(data => {
          resolve(data)
        })
        .catch(reject)
    })
  }

  getModifierAnalysis (query) {
    return new Promise((resolve, reject) => {
      this.$http.get('reports2/modifier-analysis', { params: query })
        .then(res => res.data)
        .then(data => {
          resolve(data)
        })
        .catch(reject)
    })
  }

  // ==================== VARIANT-BASED SALES REPORTS ====================

  getSalesByVariant (query) {
    return new Promise((resolve, reject) => {
      this.$http.get('reports2/sales-by-variant', { params: query })
        .then(res => res.data)
        .then(data => {
          resolve(data)
        })
        .catch(reject)
    })
  }

  getVariantPerformance (query) {
    return new Promise((resolve, reject) => {
      this.$http.get('reports2/variant-performance', { params: query })
        .then(res => res.data)
        .then(data => {
          resolve(data)
        })
        .catch(reject)
    })
  }

  getVariantTrends (query) {
    return new Promise((resolve, reject) => {
      this.$http.get('reports2/variant-trends', { params: query })
        .then(res => res.data)
        .then(data => {
          resolve(data)
        })
        .catch(reject)
    })
  }

  getVariantDetails (query) {
    return new Promise((resolve, reject) => {
      this.$http.get('reports2/variant-details', { params: query })
        .then(res => res.data)
        .then(data => {
          resolve(data)
        })
        .catch(reject)
    })
  }

  exportVariantAnalysis (query) {
    return new Promise((resolve, reject) => {
      this.$http.get('reports2/variant-export', { params: query })
        .then(res => res.data)
        .then(data => {
          resolve(data)
        })
        .catch(reject)
    })
  }

  getVariantComparison (query) {
    return new Promise((resolve, reject) => {
      this.$http.get('reports2/variant-comparison', { params: query })
        .then(res => res.data)
        .then(data => {
          resolve(data)
        })
        .catch(reject)
    })
  }

  getVariantSalesHistory (query) {
    return new Promise((resolve, reject) => {
      this.$http.get('reports2/variant-sales-history', { params: query })
        .then(res => res.data)
        .then(data => {
          resolve(data)
        })
        .catch(reject)
    })
  }

  getVariantAnalysis (query) {
    return new Promise((resolve, reject) => {
      this.$http.get('reports2/variant-analysis', { params: query })
        .then(res => res.data)
        .then(data => {
          resolve(data)
        })
        .catch(reject)
    })
  }
}
